import { Button, Modal } from "antd";
import PropTypes from "prop-types";
import styles from "../../styles/dialog.module.scss";
import { ReactNode } from "react";

// we will create a resusable delete modal, which will be just for the confirmation
interface DeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleDelete: () => void;
  title: string;
  description: ReactNode;
  confirmText: string;
  cancelText: string;
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  isOpen,
  onClose,
  handleDelete,
  cancelText,
  confirmText,
  title,
  description,
}) => {
  return (
    <Modal
      open={isOpen}
      title={<span className={styles.title}>{title}</span>}
      onCancel={onClose}
      width={480}
      footer={[
        <div key="footer" className={styles.footer}>
          <Button
            className={styles.cancel}
            key="cancel"
            style={{}}
            type="default"
            onClick={onClose}
          >
            {cancelText}
          </Button>
          <Button
            key="submit"
            className={styles.delete}
            type="primary"
            onClick={handleDelete}
          >
            {confirmText}
          </Button>
        </div>,
      ]}
    >
      {description}
    </Modal>
  );
};

export default DeleteUserModal;

DeleteUserModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
};
